import React, { FC, MouseEvent } from "react";
import { IconToggleButton, Icon, IconTypesKeys } from "@evergis/ui";

interface SeveralIconToggleProps {
  icons: IconTypesKeys[];
  disabled?: boolean;
  isSelected?: boolean;
  title?: string;
  onClick: (e?: MouseEvent<HTMLButtonElement>) => void;
}

export const SeveralIconToggle: FC<SeveralIconToggleProps> = ({ icons, ...props }) => {
  return (
    <IconToggleButton {...props}>
      {icons.map((icon, index) => (
        <Icon key={index} kind={icon} />
      ))}
    </IconToggleButton>
  );
};
